import { X } from 'lucide-react'
import { Badge } from 'src/shared/components/ui/badge'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { SearchFilters } from '../types'

interface ActiveFiltersSectionProps {
  searchFilters: SearchFilters
  onRemoveSearchFilter?: (key: keyof SearchFilters) => void
}

export const ActiveFiltersSection = ({
  searchFilters,
  onRemoveSearchFilter,
}: ActiveFiltersSectionProps) => {
  const { t } = useLocalization()
  const hasActiveSearch =
    searchFilters.articleNumber ||
    searchFilters.itemName ||
    searchFilters.source ||
    searchFilters.category

  if (!hasActiveSearch) return null

  return (
    <div className="flex flex-wrap gap-1.5 items-center pb-2">
      {searchFilters.articleNumber && (
        <Badge variant="blue" className="gap-1 px-2 py-0.5 text-xs">
          <span>
            {t('Article', 'Artikel')}: "{searchFilters.articleNumber}"
          </span>
          {onRemoveSearchFilter && (
            <button
              onClick={() => onRemoveSearchFilter('articleNumber')}
              className="ml-0.5 hover:bg-blue-200/50 rounded-full p-0.5 transition-colors"
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </Badge>
      )}
      {searchFilters.itemName && (
        <Badge variant="blue" className="gap-1 px-2 py-0.5 text-xs">
          <span>
            {t('Name', 'Namn')}: "{searchFilters.itemName}"
          </span>
          {onRemoveSearchFilter && (
            <button
              onClick={() => onRemoveSearchFilter('itemName')}
              className="ml-0.5 hover:bg-blue-200/50 rounded-full p-0.5 transition-colors"
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </Badge>
      )}
      {searchFilters.source && (
        <Badge variant="blue" className="gap-1 px-2 py-0.5 text-xs">
          <span>
            {t('Source', 'Källa')}: "{searchFilters.source}"
          </span>
          {onRemoveSearchFilter && (
            <button
              onClick={() => onRemoveSearchFilter('source')}
              className="ml-0.5 hover:bg-blue-200/50 rounded-full p-0.5 transition-colors"
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </Badge>
      )}
      {searchFilters.category && (
        <Badge variant="blue" className="gap-1 px-2 py-0.5 text-xs">
          <span>
            {t('Category', 'Kategori')}: "{searchFilters.category}"
          </span>
          {onRemoveSearchFilter && (
            <button
              onClick={() => onRemoveSearchFilter('category')}
              className="ml-0.5 hover:bg-blue-200/50 rounded-full p-0.5 transition-colors"
            >
              <X className="h-3 w-3" />
            </button>
          )}
        </Badge>
      )}
    </div>
  )
}

